import { Box, Button, Container, Grid, Typography } from '@mui/material'
import { ErrorAlert } from '~/components/common/ErrorAlert'
import { CreateCampaignContext } from '~/contexts/CreateCampaignContext'
import React, { useContext, FC } from 'react'

export const CreateFailure: FC = () => {
  const { setPageResult, campaignCreateErrors } = useContext(CreateCampaignContext)

  return (
    <Box mt={10}>
      <Box textAlign="center">
        <Typography variant="headingL" fontWeight="bold">
          キャンペーンの作成に失敗しました
        </Typography>
      </Box>
      <Container maxWidth="sm">
        <Box sx={{ my: 2 }}>
          {campaignCreateErrors && <ErrorAlert title="キャンペーンの作成に失敗しました" error={campaignCreateErrors} />}
        </Box>

        <Grid container direction="row" justifyContent="center" alignItems="center" spacing={10}>
          <Grid>
            <Button variant="outlined" onClick={() => setPageResult(undefined)}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}
